export const _defaultFr = {
    players: 'Joueurs',
    presentationTitle: `📢 Présentation du Mod RP 🎙️`,
    presentationSubTitle: `❓ Qu’est-ce que le Mod RP ?`,
    presentationText: `Le Mod RP est un outil de simulation conçu pour les joueurs de roleplay (RP)
     qui souhaitent reproduire le fonctionnement d’un Centre de Traitement des Appels (CTA) ou
     d’un Centre Opérationnel Départemental d'Incendie et de Secours (CODIS) dans leurs sessions RP.
     Cependant ce système peut s'appliquer à d'autres domaines d'activités de part sa grande polyvalence.`,
    descriptionTitle: `🛠️ À quoi sert le Mod RP ?`,
    descriptionText: `Il permet aux joueurs qui tiennent le rôle d’opérateurs CTA/CODIS de :<br />
        ✅ Gérer les appels d’urgence et créer des alertes.<br />
        ✅ Organiser les interventions en affectant des unités aux incidents.<br />
        ✅ Superviser les opérations en temps réel.<br />
        ✅ Utiliser un système radio type BER (similaire à Antares).<br />
        ✅ Envoyer des BIP pour alerter les équipes.<br />
    Grâce à lui, les interventions gagnent en réalisme et en fluidité, tout en évitant la désorganisation qui peut survenir lors de sessions RP.`,
    notAGameTitle: `🎮 Peut-on "jouer" au Mod RP ?`,
    notAGameText: `Non. Le Mod RP n’est pas un jeu, mais un outil de gestion pour les sessions de RP. 
    Il ne fonctionne pas seul et nécessite une plateforme de jeu où il peut être utilisé (comme GTA V RP).
    Les joueurs ne viennent donc pas "jouer" au Mod RP, mais l’utilisent pour améliorer et
     structurer leurs sessions RP en se mettant dans la peau des opérateurs des services de secours.`,
};

export const _defaultEn = {
    players: 'Players',
    presentationTitle: `📢 Presentation of the Mod RP 🎙️`,
    presentationSubTitle: `❓ What is the Mod RP?`,
    presentationText: `The Mod RP is a simulation tool designed for roleplay (RP) players
     who wish to reproduce the functioning of a Call Processing Center (CTA) or
     a Departmental Fire and Rescue Operations Center (CODIS) in their RP sessions.`,
    descriptionTitle: `🛠️ What is the Mod RP for?`,
    descriptionText: `It allows players who play the role of CTA/CODIS operators to:<br />
    ✅ Manage emergency calls and create alerts.<br />
    ✅ Organize interventions by assigning units to incidents.<br />
    ✅ Supervise operations in real time.<br />
    ✅ Use a BER-type radio system (similar to Antares).<br />
    ✅ Send BIPs to alert teams.<br />
    Thanks to it, interventions gain in realism and fluidity, while avoiding the disorganization that can occur during RP sessions.`,
    notAGameTitle: `🎮 Can we "play" the Mod RP?`,
    notAGameText: `No. The Mod RP is not a game, but a management tool for RP sessions. 
    It does not work alone and requires a gaming platform where it can be used (like GTA V RP).
     Players do not come to "play" the Mod RP, but use it to improve and structure their RP sessions
     by putting themselves in the shoes of emergency services operators.`,
};

export const _defaultDe = {
    players: 'Spieler',
    presentationTitle: `📢 Präsentation des Mod RP 🎙️`,
    presentationSubTitle: `❓ Was ist der Mod RP?`,
    presentationText: `Der Mod RP ist ein Simulationstool, das für Rollenspiel (RP) -Spieler entwickelt wurde
     die den Betrieb eines Call Processing Center (CTA) oder
     eines Abteilungs-Feuerwehr- und Rettungseinsatzzentrums (CODIS) in ihren RP-Sitzungen nachbilden möchten.`,
    descriptionTitle: `🛠️ Wofür ist der Mod RP?`,
    descriptionText: `Es ermöglicht Spielern, die die Rolle von CTA/CODIS-Betreibern spielen, Folgendes zu tun:<br />
        ✅ Verwalten von Notrufen und Erstellen von Warnungen.<br />
        ✅ Organisation von Interventionen durch Zuweisung von Einheiten zu Vorfällen.<br />
        ✅ Überwachen von Operationen in Echtzeit.<br />
        ✅ Verwendung eines Funkgeräts vom Typ BER (ähnlich wie Antares).<br />
        ✅ Senden von BIPs zur Alarmierung von Teams.<br />
    Dank ihm gewinnen Interventionen an Realismus und Flüssigkeit, während die Desorganisation vermieden wird, die während von RP-Sitzungen auftreten kann.`,
    notAGameTitle: `🎮 Können wir den Mod RP "spielen"?`,
    notAGameText: `Nein. Der Mod RP ist kein Spiel, sondern ein Verwaltungstool für RP-Sitzungen. 
    Er funktioniert nicht alleine und erfordert eine Spieleplattform, auf der er verwendet werden kann (wie GTA V RP).
    Spieler kommen also nicht, um den Mod RP "zu spielen", sondern verwenden ihn, um ihre RP-Sitzungen zu verbessern und zu strukturieren,
     indem sie sich in die Rolle von Notfalldienstbetreibern versetzen.`,
};
